<template>
  <div>
    <ui-modal-alert :is-open.sync="alertModalConfig.isOpen" :config="alertModalConfig" />
    <ui-modal-confirm :is-open.sync="confirmModalConfig.isOpen" :config="confirmModalConfig" />
    <notifications classes="fl-toast"/>
  </div>
</template>

<script>

import UiModalAlert from '@iflat-ui/components/modal/UiModalAlert.vue'
import UiModalConfirm from '@iflat-ui/components/modal/UiModalConfirm.vue'

import {useGlobalModalsStore} from "@iflat-ui/stores/globalModals";
export default {
  components: {UiModalAlert, UiModalConfirm},
  data() {
    return {
      globalModalStore: useGlobalModalsStore()
    }
  },
  computed: {
    alertModalConfig() {
      return this.globalModalStore.alertModalConfig
    },
    confirmModalConfig() {
      return this.globalModalStore.confirmModalConfig
    }
  },
}
</script>
